import { useState, type FormEvent } from "react";
import { site } from "@/config/site";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahgojjoh653ivfvnuq0";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honeypot = String(payload.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    payload.delete("website_alt");

    setStatus("loading");
    setFormError("");

    const body = new URLSearchParams();
    payload.forEach((value, key) => body.append(key, String(value)));

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText) as Record<string, unknown>;
      } catch {
        parsed = null;
      }
      const meta =
        parsed && typeof parsed.meta === "object" && parsed.meta !== null
          ? (parsed.meta as Record<string, unknown>)
          : undefined;
      const serverMsg = String(
        meta?.message ?? parsed?.message ?? meta?.detail ?? responseText ?? "",
      );
      const code = parsed ? String(parsed.code ?? "") : "";
      const isSpam = serverMsg.toLowerCase().includes("spam");

      if (response.ok && code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <form
      data-readdy-form
      id="newsletter-form"
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col gap-2 sm:flex-row">
        <label className="sr-only" htmlFor="newsletter-email">
          邮箱地址
        </label>
        <input
          id="newsletter-email"
          name="email"
          type="email"
          required
          placeholder="输入邮箱，订阅每日瓜报"
          className="w-full rounded-md border border-background-700/60 bg-background-50/10 px-3 py-2.5 text-sm text-background-50 placeholder:text-background-300/70 focus:border-accent-400 focus:outline-none focus:ring-2 focus:ring-accent-400/40"
        />
        <input
          className="form-honeypot"
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "loading" ? "提交中…" : "立即订阅"}
        </button>
      </div>
      {status === "success" && (
        <p className="mt-2 text-xs text-accent-300">
          订阅成功，新的瓜料会第一时间送到 {site.name} 的订阅邮箱。
        </p>
      )}
      {status === "error" && <p className="mt-2 text-xs text-primary-300">{formError}</p>}
    </form>
  );
}